module.exports = __webpack_public_path__ + "static/media/01_Ministeredesaffairesetrangeres.3a9b556c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_affaires-etrangeres/01_Ministeredesaffairesetrangeres.jpg
// module id = 336
// module chunks = 37